// Main js file
document.addEventListener('DOMContentLoaded', () => {
    const layout = document.querySelector('.layout');
    const pageY = () => {
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    if (!layout.classList.contains('removeSmoothScroll')) {
        window.addEventListener("optimizedScroll", function () {
            if (pageY() > 10) {
                document.body.classList.add("is-scrolled");
            } else {
                document.body.classList.remove("is-scrolled");
            }
        });
    }

    // Accordeon
    const item = document.getElementsByClassName('accordeon__item');

    for (let i = 0; i < item.length; i++) {
        item[i].addEventListener('click', (el) => {

            el.currentTarget.classList.toggle('open');

            for (let i = 0; i < item.length; i++) {
                if (item[i] !== el.currentTarget && item[i].className === "accordeon__item open") {
                    item[i].classList.remove('open');
                }
            }
        });
    };

    // Copy text
    document.querySelector("#copyButton").addEventListener("click", function () {
        navigator.clipboard.writeText(document.querySelector("#copyAddress").innerText).then(function () {
            document.querySelector("#copyButton span").innerText = 'Copied!';
        }).catch(function (error) {
            console.error('Error:', error);
        });
    });

});

// Mob menu
(function () {
    let trigger = document.querySelector('.js-menu-trigger');
    let menuOverlay = document.querySelector('.js-header-overlay');
    if (trigger) {
        trigger.onclick = () => {
            document.body.classList.toggle('menu-open');
        };
    }
    if (menuOverlay) {
        menuOverlay.onclick = () => {
            document.body.classList.remove('menu-open');
        };
    }
})();

(function () {
    var throttle = function (type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function () {
            if (running) {
                return;
            }
            running = true;
            requestAnimationFrame(function () {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            });
        };
        obj.addEventListener(type, func);
    };

    throttle("resize", "optimizedResize");
    throttle("scroll", "optimizedScroll");
})();